export default {
  translation: {
    applyNow: {
      mainCTA: "Apply Now",
      floifyVerifyVoa: {
        title: "Connect your accounts for faster approval",
        subtitle:
          "Securely add your checking & savings accounts and we'll gather the information and documents needed.",
        whyConnect: "Why should I connect my accounts?",
        connectButton: "Connect account",
        connecting: "Connecting...",
        enterManually: "Enter account details manually",
        mastercardSecurity:
          "Secure connection through Mastercard — works with all major US banks. We never see or store your password.",
        lenderContinue: "Continue",
      },
      ocrAutofill: {
        continueButton: "Continue",
        savingButton: "Saving",
        connectOverlayModal: {
          title: "Connect your accounts",
          connectingTitle: "Preparing your connection",
          connectingSubtitle: "This will just take a moment.",
          activeSubtitle:
            "A new window or tab has been opened where you can connect your accounts. Return here once you're done.",
          processingTitle: "Gathering your accounts",
          processingSubtitle: "This should only take a few seconds.",
          closeButton: "Close",
          cancelButton: "Cancel",
        },
        confirmDetailsModal: {
          title: "Confirm a few details first",
          subtitle:
            "We'll use this to securely verify your identity and open the window to connect your bank accounts.",
          dateOfBirthLabel: "Date of birth",
          currentAddressLabel: "Current address",
          streetPlaceholder: "Street",
          unitPlaceholder: "Apt, suite (optional)",
          cityPlaceholder: "City",
          statePlaceholder: "State",
          postalCodePlaceholder: "Zip code",
          notNow: "Not now",
        },
        whyConnectModal: {
          title: "Why should I connect my bank accounts?",
          gotIt: "Got it",
          skipPaperworkHeading: "Skip the paperwork",
          skipPaperworkSubheading:
            "We'll pull your account details and recent transaction history for you.",
          credentialsHeading: "Your credentials stay private",
          credentialsSubheading: "We never see or store your password.",
          fasterApprovalHeading: "Faster approval",
          fasterApprovalSubheading:
            "Connecting your account speeds up the verification process.",
        },
        documentProcessingCompleteHeading: "Finished reviewing your documents",
        documentProcessingCompleteSubheading:
          "Please complete the remaining questions.",
        documentProcessingPendingHeading1: "We're reviewing your documents",
        documentProcessingPendingHeading2: "Finishing up your document review",
        documentProcessingPendingSubheading1:
          "Please answer a few questions while we finish.",
        documentProcessingPendingSubheading2:
          "Please complete the remaining questions.",
        loanPurposeScreen: {
          title: "Which type of loan are you applying for?",
        },
        inputValidation: {
          date: {
            invalidEnd: "Invalid end date",
            invalidGeneric: "Invalid date",
            invalidStart: "Invalid start date",
            requireDateOfBirth: "Enter a date of birth",
            requireEnd: "Enter an end date",
            requireLessThan100Years: "Date must be more recent",
            requireMaximum: "Date cannot be this high",
            requireMinimum: "Date cannot be this low",
            requireNotFuture: "Date cannot be in the future",
            requireStart: "Enter a start date",
            requireStartBeforeEnd:
              "Check your dates — the start date must be before the end date",
          },
          money: {
            invalidGeneric: "Enter a valid currency amount",
            requireGeneric: "Enter a currency amount",
            requirePositive: "Currency must be positive",
          },
          phone: {
            invalidGeneric: "Enter a valid 10-digit phone number",
            requireGeneric: "Enter a phone number",
          },
          string: {
            invalidPostalCode: "Invalid zip code",
            maxCount: "Cannot exceed {{count}} characters",
            requireCity: "Enter a city",
            requireCountry: "Enter a country",
            requireGeneric: "This field is required",
            requireJobTitle: "Enter a job title",
            requirePostalCode: "Enter a zip code",
            requireState: "Enter a state",
            invalidState: "Enter a valid state",
            requireStreet: "Enter a street address",
          },
        },
        networkIntercept: {
          error: {
            "400General": "An error occurred, check your input and try again",
            "500General": "Something went wrong",
          },
        },
        voieProcessingPendingHeading: "We're retrieving your income documents",
      },
      ssoLoginCard: {
        cardHeading: "Start a loan application",
        cardSubheading:
          "Beginning the loan application process? You’re in the right place! Get started by creating an account.",
        confirmEmailInputLabel: "Confirm Email",
        continueButton: "Continue with email",
        emailInputLabel: "Email",
        passwordInputLabel: "Password",
        passwordVisibilityHide: "Hide",
        passwordVisibilityShow: "Show",
      },
    },
    auth: {
      back: "Back",
      continueWithProvider: "Continue with {{provider}}",
      emailNotFoundLink: "log in",
      emailNotFoundPrefix:
        "We couldn’t find that email! Sign up for a new account here, or try to",
      emailNotFoundSuffix: "again.",
      forgotPasswordSuggestive: "Forgot password?",
      goBack: "Go back",
      greetReturningUser: "Welcome back",
      logInOrCreateAccount: "Log In or Create an Account",
      logInWithMicrosoft: "Log in with Microsoft",
      loginButton: "Log in",
      loginCredentialsMismatch:
        "The email/password combination you entered does not match our records",
      loginPromptDirect: "Log in with your account.",
      loginPromptSuggestive: "Have an account?",
      microsoftLogoAlt: "Microsoft logo",
      next: "Next",
      noAccountSuggestive: "Don't have an account?",
      noPassword: {
        accountAlreadyCreated: "Account already created",
        accountCreatedButtonSuffix: "button below.",
        accountCreatedPrefix: "{{name}} has already created an account for",
        accountCreatedResendMiddle:
          ". Check your email to find the password setup link, or click the",
        accountCreatedResendSuffix: "button below to create your password.",
        accountCreatedSetupLinkMiddle:
          ". Check your email to find the password setup link. If you don’t see it, click the",
        applicationInProgress: "Application in progress",
        applicationInProgressMiddle:
          ", already has an application in progress. Check your email to find the application link, or click",
        applicationInProgressPrefix: "The email address you provided,",
        applicationInProgressSuffix: "below to access your application.",
        applicationSubmitted:
          "You successfully submitted a loan application! We’ll email you as soon as it’s ready.",
        applicationUnderReview: "Application under review",
        changeEmailAddress: "Change Email Address",
        checkYourEmail: "Check your email",
        contactSupport: "Contact Support",
        helpOnItsWay: "Help is on its way!",
        loanOfficerWillContactMiddle:
          ". If this email address is incorrect, click",
        loanOfficerWillContactPrefix:
          "Your loan officer, {{name}}, will contact you shortly at",
        loanOfficerWillContactSuffix: "below.",
        resendLink: "Resend Link",
        resentApplicationPrefix:
          "We just resent an email with a link to your application to",
        resentMiddle: ". If you don’t see it, check your spam folder or click",
        resentPrefix: "We just resent the email to",
        resentSuffix: "below for help.",
        sentPrefix: "We just sent an email to",
        sentSuffix:
          ". Check your inbox and click the verification link to start your application!",
        sentenceEnd: ".",
        verifyHeading: "Verify your Email",
      },
      or: "Or",
      passwordInputAria: "Password",
      passwordRequirements: {
        characters: "characters",
        heading: "Password must contain at least",
        lowerCaseLetters: "lowercase letter",
        numbers: "number",
        specialCharacters: "special character (!, #, %, etc.)",
        upperCaseLetters: "uppercase letter",
      },
      resetPasswordLink: "reset your password",
      resetPasswordPrefix: "You can",
      resetPasswordSuffix: "or try again.",
      setUpAccountHeading: "Welcome! Let’s set up your account",
      ssoProviderLogoAlt: "{{provider}} logo",
      termsAgreementCheckboxPrefix: "I agree to",
      termsAgreementLink: "Terms of Use and Privacy Policy",
      termsAgreementPrefix: "By signing in, you agree to the",
      termsCheckboxAria: "Floify Terms and Conditions",
    },
    landingPage: {
      calculators: {
        common: {
          accessCalculators: "Access Calculators",
          currentTerm: "Current Term",
          hideAdvancedOptions: "Hide Advanced Options",
          perMonth: "/mo",
          perMonthAbbr: "mo",
          perMonthTag: "/ mo",
          perYearAbbr: "yr",
          resultsBreakdown: "Results Breakdown",
          showAdvancedOptions: "Show Advanced Options",
          showPaymentBreakdown: "Show Payment Breakdown",
          term: "Term",
          yourPayment: "Your Payment",
        },
        debtToIncome: {
          inputs: {
            alimonyChildSupport: "Alimony/Child Support",
            annualIncome: "Annual Income",
            carLoanPayments: "Car Loan Payments",
            minCreditCardPayments: "Min. Credit Card Payments",
            mortgagePayment: "Mortgage Payment",
            otherLoanOrDebtPayments: "Other Loan or Debt Payments",
            secondaryHomeExpenses: "Secondary Home Expenses",
            studentLoanPayments: "Student Loan Payments",
          },
          legend: {
            debts: "Debts",
            mortgage: "Mortgage",
            remaining: "Remaining",
          },
          ratioLabel: "Debt-to-Income Ratio is",
          series: {
            monthlyDebts: "Monthly Debts",
            mortgagePayment: "Mortgage Payment",
            remainingIncome: "Remaining Mo. Income",
          },
          showRatioBreakdown: "Show Ratio Breakdown",
          title: "Debt-to-Income Calculator",
        },
        mortgage: {
          inputs: {
            downPayment: "Down Payment",
            downPaymentPercent: "Down payment percent",
            homePrice: "Home Price",
            homeownersAssociation: "Homeowners Association",
            homeownersInsurance: "Homeowners Insurance",
            interestRate: "Interest Rate",
            loanProgram: "Loan Program",
            propertyTax: "Property Tax",
          },
          loanProgram: {
            fifteenYearFixed: "15-year fixed",
            thirtyYearFixed: "30-year fixed",
          },
          results: {
            homeownersAssociation: "Homeowners Association",
            insurance: "Insurance",
            principalAndInterest: "Principal + Interest",
            taxes: "Taxes",
          },
          title: "Mortgage Calculator",
        },
        rates: {
          amortization: {
            arm: "ARM",
            fixed: "fixed",
          },
          aprValue: "{{value}}% APR",
          creditScore: {
            exceptional: "800+ (Exceptional)",
            fair: "580-669 (Fair)",
            good: "670-739 (Good)",
            lessThan580: "Less than 580",
            veryGood: "740-799 (Very good)",
          },
          inputs: {
            creditScore: "Credit Score",
            downPayment: "Down Payment",
            downPaymentPercent: "Down payment percent",
            firstTimeBuyer: "First Time Buyer",
            homePrice: "Home Price",
            homeValue: "Home Value",
            homeownersAssociation: "Homeowners Association",
            homeownersInsurance: "Homeowners Insurance",
            loanBalance: "Loan Balance",
            loanPurpose: "Loan Purpose",
            loanTerm: "Loan Term",
            militaryVeteran: "Military/Veteran",
            propertyCounty: "Property County",
            propertyState: "Property State",
            propertyTax: "Property Tax",
            propertyTaxPercent: "Property tax percent",
            propertyType: "Property Type",
            propertyUse: "Property Use",
            selfEmployed: "Self Employed",
          },
          intro:
            "Compare loan options using today's mortgage rates. Then click <i>Apply Now</i> to get your personalized rate quote!",
          loanPurpose: {
            purchase: "Purchase",
            refinance: "Refinance",
          },
          loanTerm: {
            years: "{{count}} year",
          },
          locationNotChosen:
            "Select the state and county of the property you’re looking to buy to view today’s best mortgage rates!",
          noRatesFound:
            "We couldn’t find any rates for the values you entered. Try adjusting your criteria, or begin your application!",
          pmiDisclaimer:
            "* Monthly payment amount does not include private mortgage insurance.",
          propertyType: {
            condo: "Condo",
            cooperative: "Cooperative",
            manufactured: "Mobile or manufactured",
            modular: "Modular",
            singleFamily: "Single family",
            townhouse: "Townhouse",
          },
          propertyUse: {
            investmentProperty: "Investment property",
            primaryResidence: "Primary residence",
            secondHome: "Second home",
          },
          rateValue: "{{value}}% rate",
          showFewerRates: "Show fewer rates",
          showMoreRates: "Show more rates",
          termDescription: "{{count}} year {{amortization}}",
          title: "Rates",
        },
        refinance: {
          breakevenIn: "Breakeven in",
          breakevenMonths_one: "{{count}} month",
          breakevenMonths_other: "{{count}} months",
          chart: {
            costs: "Costs",
            yearsAbbr_one: "{{count}}yr",
            yearsAbbr_other: "{{count}}yrs",
          },
          couldCost: "Refinancing could cost you",
          couldSave: "Refinancing could save you",
          currentHeading: "CURRENT",
          hideDetails: "Hide Details",
          inputs: {
            cashOut: "Cash Out",
            currentTermOfLoan: "Current term of loan",
            interestRate: "Interest Rate",
            loanAmount: "Loan Amount",
            newLoanAmount: "New Loan Amount",
            newTerm: "New Term",
            originationYear: "Origination Year",
            refinanceFees: "Refinance Fees",
            rollFees: "Roll Fees into New Loan?",
          },
          lifetimeCost: "Extra lifetime cost of new loan",
          lifetimeSavings: "Lifetime savings of new loan",
          newHeading: "NEW",
          newMonthlyPayment: "With a new monthly payment of",
          notAvailable: "N/A",
          savingsAfterYears: "Savings after {{count}} years",
          showDetails: "Show More Details",
          termYears: "{{count}} years",
          title: "Refinance Calculator",
          tooltips: {
            cashOut:
              "The amount of property equity you’d like to access in a cash-in-hand amount. Typically used for debt consolidation, home improvements, or anything else you wish.",
            originationYear: "The year you took out the loan.",
          },
        },
        tabs: {
          debtToIncome: "Debt-to-Income",
          mortgage: "Mortgage",
          rates: "Rates",
          refinance: "Refinance",
        },
      },
      footer: {
        help: "Help",
        privacyAndTerms: "Privacy & Terms",
      },
      head: {
        title: "Apply Now",
      },
      header: {
        logoAlt: "Lender Logo",
      },
      leadGen: {
        countyRequired: "County is required",
        emailAddress: "Email Address",
        firstName: "First Name",
        firstNameRequired: "First Name is required",
        heading: "Tell us a bit about yourself",
        lastName: "Last Name",
        lastNameRequired: "Last Name is required",
        marketingConsent:
          "By submitting this you consent to receive marketing communications.",
        phoneNumber: "Phone Number",
        phoneRequired: "Phone Number is required",
        propertyCounty: "Property County",
        propertyState: "Property State",
        stateRequired: "State is required",
        submit: "Access Mortgage Calculators",
      },
      mobileModal: {
        close: "Close",
      },
      ourPartner: "OUR PARTNER",
      profile: {
        address: "Address:",
        branchLicensePrefix: "Branch",
        companyLicensePrefix: "Company",
        contactPerson: "Contact {{name}}",
        directPhone: "Direct:",
        directPhoneAria: "Direct phone: {{phone}}",
        emailAria: "Email address: {{email}}",
        licensedIn: "Licensed in {{states}}",
        mobilePhone: "Mobile:",
        mobilePhoneAria: "Mobile phone: {{phone}}",
        moreLicenses: "+{{count}} more",
        nmlsNumber: "NMLS #{{nmlsId}}",
        officePhone: "Office:",
        officePhoneAria: "Office phone: {{phone}}",
      },
      share: {
        ariaLabel: "Share this page",
        cancel: "Cancel",
        closeModal: "Close modal",
        copied: "Copied",
        copiedToClipboard: "Copied to clipboard!",
        copy: "Copy",
        copyToClipboard: "Copy to clipboard",
        done: "Done",
        emailBody: "Click this link to visit {{name}}’s page: {{link}}",
        emailPlaceholder: "Email Address",
        emailSubject: "{{name}}'s page has been shared with you",
        link: "Share this page",
        modalTitle: "Share This Page",
        or: "OR",
        send: "Send",
        shareViaEmail: "Share via Email",
        shareableLink: "Shareable Link",
      },
    },
    validation: {
      emailAddressInvalid: "Please enter a valid email address.",
      emailInUse:
        'An account with that email address already exists. Click "Log In" instead.',
      emailMismatch: "Please make sure your email addresses match.",
      emailRequired: "Email is required",
      floifyAddress:
        "You cannot use a floify.com email address. Please use a different email address.",
      invalidEmail: "Invalid Email",
      invalidPassword: "Please enter a valid password.",
      lenderAddress:
        "This email belongs to a lender in Floify and cannot be reused. Enter a different email to continue.",
      passwordRequired: "Please enter a password.",
      termsRequired:
        "Please make sure you have agreed to Floify's terms before continuing",
    },
  },
};
